/* eslint-disable guard-for-in */
import { createSelector } from "reselect";
import orderBy from "lodash/orderBy";
import { tierNames } from "../../common/helpers/Constant";

const getJax = (state, isGene) =>
  __IS_COMPONENTS_PORTAL__ && isGene
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.jax_ckb
    : state?.variantResult?.jax_ckb;

const getJaxVersion = createSelector(getJax, (jax) => jax && jax[0].version);

const getJaxData = createSelector(getJax, (jax) => {
  return jax && jax[0];
});

const getAMPTier = createSelector(getJaxData, (data) => {
  if (data) {
    let inputArray = [];
    if (data && data?.evidence?.length > 0) {
      inputArray = data.evidence;
    } else if (
      data &&
      data.evidence === null &&
      data.extended_evidence &&
      data.extended_evidence.length > 0
    ) {
      inputArray = data.extended_evidence;
    } else {
      return null;
    }

    const tempArray = [];

    inputArray.forEach((item) => {
      tempArray.push(tierNames[item.amp_tier]);
    });

    if (tempArray.includes("Tier I")) {
      return "Tier I";
    }
    if (tempArray.includes("Tier II")) {
      return "Tier II";
    }
    if (tempArray.includes("Tier III")) {
      return "Tier III";
    }
    if (tempArray.includes("Tier IV")) {
      return "Tier IV";
    }
    return null;
  }
  return null;
});

const getEvidenceCount = createSelector(getJaxData, (data) => {
  if (data) {
    if (data && data.evidence && data?.evidence?.length > 0) {
      return data.evidence.length;
    }
    if (data && data.extended_evidence && data.extended_evidence.length > 0) {
      return data.extended_evidence.length;
    }
  }
  return null;
});

const getHighestCancerType = createSelector(getJaxData, (data) => {
  if (data) {
    let inputArray = [];
    if (data && data.evidence && data.evidence.length > 0) {
      inputArray = data.evidence;
    } else {
      return null;
    }
    const tempArray = [];
    const key = "indication";
    inputArray.forEach((record) => {
      const customProperty = record[key];
      if (tempArray.hasOwnProperty(customProperty)) {
        tempArray[customProperty] += 1;
      } else {
        tempArray[customProperty] = 1;
      }
    });
    const chartData = [];
    let value = "";
    for (const item in tempArray) {
      let obj = {};
      value = item;
      obj = { key: value, value: tempArray[item] };
      chartData.push(obj);
    }
    return orderBy(chartData, (s) => s.value, ["desc"])[0];
  }
  return null;
});

export {
  getJax,
  getJaxVersion,
  getJaxData,
  getAMPTier,
  getEvidenceCount,
  getHighestCancerType,
};
